














































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class Parallax extends Vue {
    articles = [
        {
          src: '../assets/cat_mouse.jpg',
          title: 'Jimmy Sees The Enemy',
          text: 'What to do when you spot a mouse.',
        },
        {
          src: '../assets/puppy_cat.jpg',
          title: 'How I Conquered the Dog',
          text: 'How to tame the new puppy.',
        },
        {
          src: '../assets/squirrel.jpg',
          title: 'What is that!?',
          text: 'Hooman conspiracy theorists call it a squirrel.',
        },
      ];

    features = [
        {
          icon: 'fal fa-claw-marks',
          title: 'Sharp Claws',
          text: 'I ketch miceez for u.',
        },
        {
          icon: 'fal fa-alicorn',
          title: 'Soft Fur',
          text: 'If u petz me I purzzzzz.',
        },
        {
          icon: 'fal fa-cat-space',
          title: 'Very Smart',
          text: 'I goez to Mars and find u space catnips!',
        },
      ];

      stats = [
        ['29k', 'Spiders Eaten'],
        ['220+', 'Sunbeams Enjoyed'],
        ['55', 'Naps Today'],
        ['9', 'Lives'],
      ]
}
